import React from 'react'
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgAutoplay from "lightgallery/plugins/autoplay";
import lgVideo from "lightgallery/plugins/video";
import lgShare from "lightgallery/plugins/share";
import lgRotate from "lightgallery/plugins/rotate";
const CRMVendor = () => {
  return (
    <>
      <section id="third" className="powerpoint-sec facts bg2 third">
        <div className="container">
          <div className="section-title mt-4">
            <br />
            <h2 className="animated fadeInDown">Vendor</h2>
            <div className="bar" />
            <div className="mt-4">
              <div className="row">
                <div className="col-lg-12">
                  <ul
                    className="nav nav-tabs app-nav focus tabs-width"
                    id="myTab-partner"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link active"
                        id="android-tab"
                        data-toggle="tab"
                        href="#android-partner"
                        role="tab"
                        aria-controls="android"
                        aria-selected="false"
                      >
                        {" "}
                        <span>
                          <i className="bx bxl-android" />
                        </span>
                        Android App
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link"
                        id="ios-tab"
                        data-toggle="tab"
                        href="#ios-partner"
                        role="tab"
                        aria-controls="ios"
                        aria-selected="false"
                      >
                        {" "}
                        <span>
                          <i className="bx bxl-apple" />
                        </span>
                        iOS App
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="nav-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="android-partner"
                      role="tabpanel"
                      aria-labelledby="android-tab"
                    >
                      <div className="row shadow m-2">
                        <div className="col-md-12 p-0">
                          <div>
                            <ul
                              className="nav nav-tabs mesee focus bg-dark-bg feature-tabs-width"
                              id="myTab"
                              role="tablist"
                            >
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link active btn text-white"
                                  id="home-tab-pa"
                                  data-toggle="tab"
                                  href="#home-pa"
                                  role="tab"
                                  aria-controls="home"
                                  aria-selected="true"
                                >
                                  About
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="profile-tab-pa"
                                  data-toggle="tab"
                                  href="#profile-pa"
                                  role="tab"
                                  aria-controls="profile"
                                  aria-selected="false"
                                >
                                  Features
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="audio-tab-pa"
                                  data-toggle="tab"
                                  href="#audio-pa"
                                  role="tab"
                                  aria-controls="audio"
                                  aria-selected="false"
                                >
                                  Gallery
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade show active"
                                id="home-pa"
                                role="tabpanel"
                                aria-labelledby="home-tab-pa"
                              >
                                {/* <div class="Description mt-5">
                            <h6 class="text-left">Gallery</h6>
                          </div> */}
                                <div className="shadow-none p-3 mb-5  bg-white rounded">
                                  <div className="row">
                                    <div className="col-lg-7">
                                      <div className="mt-5">
                                        <img
                                          src="assets/img/CRM/image-3.webp"
                                          className="animated fadeInLeft img-fluid" alt="Project Screens"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-5">
                                      <h3 className="mt-3 animated fadeInUp ease-out-circ d2 a-1 f2 fw3">
                                        CRM-Fixfella
                                      </h3>
                                      <p className="animated bounceIn ease-in-quad d-2 mt4 text-justify p-2">
                                        Once the call is accepted by the dealer, he
                                        will assign the Technician and then technician
                                        will visit at the place. If the complaint
                                        which is raised by the customer is resolved
                                        then technician will close the complaint but
                                        that will be soft close. The calls which are
                                        closed by the dealer or technician will always
                                        be soft close. If the company is not resolved
                                        then the complaint status will be pending with
                                        the remark.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="profile-pa"
                                role="tabpanel"
                                aria-labelledby="profile-tab-pa"
                              >
                                {/* <div class="Description mt-5">
                        <h6 class="text-left">Feature</h6>
                      </div> */}
                                <div className="shadow-none py-5 mb-5 bg-light rounded">
                                  <div className="row px-5">
                                    <div className="col-lg-4 mb-2">
                                      <div>
                                        <div
                                          className="list-group"
                                          id="list-tab"
                                          role="tablist"
                                        >
                                          {" "}
                                          <a
                                            className="list-group-item list-group-item-action active"
                                            id="list-home-list-f13"
                                            data-toggle="list"
                                            href="#list-home-f13"
                                            role="tab"
                                            aria-controls="home-f13"
                                          >
                                            Create Account
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-profile-list-f14"
                                            data-toggle="list"
                                            href="#list-profile-f14"
                                            role="tab"
                                            aria-controls="profile-f14"
                                          >
                                            Select Service
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-messages-list-f15"
                                            data-toggle="list"
                                            href="#list-messages-f15"
                                            role="tab"
                                            aria-controls="messages-f15"
                                          >
                                            Track Your Order
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-settings-list-f16"
                                            data-toggle="list"
                                            href="#list-settings-f16"
                                            role="tab"
                                            aria-controls="settings-f16"
                                          >
                                            Rate Your Partner
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-next-list-f17"
                                            data-toggle="list"
                                            href="#list-next-f17"
                                            role="tab"
                                            aria-controls="next-f17"
                                          >
                                            Help Center
                                          </a>
                                          <a
                                            className="list-group-item list-group-item-action"
                                            id="list-tonext-list-f18"
                                            data-toggle="list"
                                            href="#list-tonext-f18"
                                            role="tab"
                                            aria-controls="tonext-f18"
                                          >
                                            Profile Details
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-8">
                                      <div className="border shadow-none p-3">
                                        <div
                                          className="tab-content"
                                          id="nav-tabContent"
                                        >
                                          <div
                                            className="tab-pane fade show active"
                                            id="list-home-f13"
                                            role="tabpanel"
                                            aria-labelledby="list-home-list-f13"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="#">Create Account</h5>
                                              <li>
                                                You can Create an Account Use your
                                                Mobile / Email.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-profile-f14"
                                            role="tabpanel"
                                            aria-labelledby="list-profile-list-f14"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="">Select Service</h5>
                                              <li>Select Services</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-messages-f15"
                                            role="tabpanel"
                                            aria-labelledby="list-messages-list-f15"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Track Your Order</h5>
                                              <li>Track Your Job Order</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-settings-f16"
                                            role="tabpanel"
                                            aria-labelledby="list-settings-list-f16 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="">Rate Your Partner</h5>
                                              <li>
                                                After Services Rate your Partner.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-next-f17"
                                            role="tabpanel"
                                            aria-labelledby="list-next-list-f17 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5 className="">Help Center</h5>
                                              <li>
                                                Take Support from your Help Center.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-tonext-f18"
                                            role="tabpanel"
                                            aria-labelledby="list-tonext-list-f18 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Profile Details</h5>
                                              <li>See Your profile Details.</li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="audio-pa"
                                role="tabpanel"
                                aria-labelledby="audio-tab-pa"
                              >
                                {/* <div class="Description mt-5">
                        <h6 class="text-left">Gallery</h6>
                      </div> */}
                                <div className="shadow-none p-3 mb-5 bg-light rounded">
                                  <section className="container">
                                    <div className="row gallery py-5">
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-1.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-1.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-2.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-2.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-3.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-3.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-Android-4.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-Android-4.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="ios-partner"
                      role="tabpanel"
                      aria-labelledby="ios-tab"
                    >
                      <div className="row shadow m-2">
                        <div className="col-md-12 p-0">
                          <div>
                            <ul
                              className="nav nav-tabs mesee focus bg-dark-bg feature-tabs-width"
                              id="myTab"
                              role="tablist"
                            >
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link active btn text-white"
                                  id="home-tab-pi"
                                  data-toggle="tab"
                                  href="#home-pi"
                                  role="tab"
                                  aria-controls="home"
                                  aria-selected="true"
                                >
                                  About
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="profile-tab-pi"
                                  data-toggle="tab"
                                  href="#profile-pi"
                                  role="tab"
                                  aria-controls="profile"
                                  aria-selected="false"
                                >
                                  Features
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                {" "}
                                <a
                                  className="nav-link btn text-white"
                                  id="audio-tab-pi"
                                  data-toggle="tab"
                                  href="#audio-pi"
                                  role="tab"
                                  aria-controls="audio"
                                  aria-selected="false"
                                >
                                  Gallery
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade show active"
                                id="home-pi"
                                role="tabpanel"
                                aria-labelledby="home-tab-pi"
                              >
                                {/* <div class="Description mt-5">
                            <h6 class="text-left">Gallery</h6>
                          </div> */}
                                <div className="shadow-none p-3 mb-5  bg-white rounded">
                                  <div className="row">
                                    <div className="col-lg-7">
                                      <div className="mt-5">
                                        <img
                                          src="assets/img/CRM/image-4.webp"
                                          className="animated fadeInLeft img-fluid" alt="Project Screens"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-5">
                                      <h3 className="mt-3 animated fadeInUp ease-out-circ d2 a-1 f2 fw3">
                                        CRM-Fixfella
                                      </h3>
                                      <p className="animated bounceIn ease-in-quad d-2 mt4 text-justify p-2">
                                        Once the call is accepted by the dealer, he
                                        will assign the Technician and then technician
                                        will visit at the place. If the complaint
                                        which is raised by the customer is resolved
                                        then technician will close the complaint but
                                        that will be soft close. The calls which are
                                        closed by the dealer or technician will always
                                        be soft close. If the company is not resolved
                                        then the complaint status will be pending with
                                        the remark.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="profile-pi"
                                role="tabpanel"
                                aria-labelledby="profile-tab-pi"
                              >
                                {/*  <div class="Description mt-5">
                        <h6 class="text-left">Feature</h6>
                      </div> */}
                                <div className="shadow-none py-5 mb-5 bg-light rounded">
                                  <div className="row">
                                    <div className="col-lg-4 mb-2">
                                      <div
                                        className="list-group"
                                        id="list-tab"
                                        role="tablist"
                                      >
                                        {" "}
                                        <a
                                          className="list-group-item list-group-item-action active"
                                          id="list-home-list-f19"
                                          data-toggle="list"
                                          href="#list-home-f19"
                                          role="tab"
                                          aria-controls="home-f19"
                                        >
                                          Create Account
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-profile-list-f20"
                                          data-toggle="list"
                                          href="#list-profile-f20"
                                          role="tab"
                                          aria-controls="profile-f20"
                                        >
                                          Select Service
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-messages-list-f21"
                                          data-toggle="list"
                                          href="#list-messages-f21"
                                          role="tab"
                                          aria-controls="messages-f21"
                                        >
                                          Track Your Order
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-settings-list-f22"
                                          data-toggle="list"
                                          href="#list-settings-f22"
                                          role="tab"
                                          aria-controls="settings-f22"
                                        >
                                          Rate Your Partner
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-next-list-f23"
                                          data-toggle="list"
                                          href="#list-next-f23"
                                          role="tab"
                                          aria-controls="next-f23"
                                        >
                                          Help Center
                                        </a>
                                        <a
                                          className="list-group-item list-group-item-action"
                                          id="list-tonext-list-f24"
                                          data-toggle="list"
                                          href="#list-tonext-f24"
                                          role="tab"
                                          aria-controls="tonext-f24"
                                        >
                                          Profile Details
                                        </a>
                                      </div>
                                    </div>
                                    <div className="col-lg-8">
                                      <div className="border shadow-none p-3">
                                        <div
                                          className="tab-content"
                                          id="nav-tabContent"
                                        >
                                          <div
                                            className="tab-pane fade show active"
                                            id="list-home-f19"
                                            role="tabpanel"
                                            aria-labelledby="list-home-list-f19"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Create Account</h5>
                                              <li>
                                                You can Create an Account Use your
                                                Mobile / Email.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-profile-f20"
                                            role="tabpanel"
                                            aria-labelledby="list-profile-list-f20"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Select Service</h5>
                                              <li>Select Services</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-messages-f21"
                                            role="tabpanel"
                                            aria-labelledby="list-messages-list-f21"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Track Your Order</h5>
                                              <li>Track Your Job Order</li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-settings-f22"
                                            role="tabpanel"
                                            aria-labelledby="list-settings-list-f22 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Rate Your Partner</h5>
                                              <li>
                                                After Services Rate your Partner.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-next-f23"
                                            role="tabpanel"
                                            aria-labelledby="list-next-list-f23 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Help Center</h5>
                                              <li>
                                                Take Support from your Help Center.
                                              </li>
                                            </ul>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="list-tonext-f24"
                                            role="tabpanel"
                                            aria-labelledby="list-tonext-list-f24 list-color"
                                          >
                                            <ul className="list-group list-group-flush text-left animated fadeInUp ease-out-circ d-1 a-2 list-color">
                                              <h5>Profile Details</h5>
                                              <li>See Your profile Details.</li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="audio-pi"
                                role="tabpanel"
                                aria-labelledby="audio-tab-pi"
                              >
                                {/* <div class="Description mt-5">
                        <h6 class="text-left">Gallery</h6>
                      </div> */}
                                <div className="shadow-none p-3 mb-5 bg-light rounded">
                                  <section className="container">
                                    <div className="row gallery py-5">
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-iOS.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-iOS.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-iOS-2.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-iOS-2.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-iOS-3.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-iOS-3.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                      <div className="col-lg-3 col-md-4 col-xs-6 thumb">
                                      <LightGallery speed={500} plugin={[lgThumbnail, lgZoom, lgAutoplay, lgVideo, lgShare, lgRotate]}>
                                        <a href="assets/img/CRM/CRM-iOS-4.webp">
                                          <figure>
                                            <img
                                              className="img-fluid img-thumbnail"
                                              src="assets/img/CRM/CRM-iOS-4.webp"
                                              alt="Project Screens"
                                            />
                                          </figure>
                                        </a>
                                        </LightGallery>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default CRMVendor